document.addEventListener("DOMContentLoaded", async function () {
  "use strict";

  var brands = [
    "brother",
    "laserjet",
    "hp",
    "lexmark",
    "canon",
    "casio",
    "dell",
    "epson",
    "pg",
    "pgi",
    "tn",
    "dr",
  ];

  var cartrighesCompatibles = document.querySelector(".cartrighes-compatibles");
  if (cartrighesCompatibles) {
    var title = cartrighesCompatibles.dataset.title
      .trim()
      .toLowerCase()
      .replace(/\bprinter\b|imprimante/g, "")
      .replace(/\//g, " ")
      .trim();

    var found = false;
    var brand;

    for (var i = brands.length - 1; i >= 0; --i) {
      if (found) {
        break;
      }

      if (title.includes(brands[i]) && !title.endsWith(brands[i])) {
        brand = brand == "PG" && title.includes("PGI") ? "PGI" : brands[i];
        title = title.replace(brand, "").trim();
        found = true;
      }
    }

    var final = title
      .split(" ")
      .filter((arg) => arg.length > 0 && arg != " ")
      .map((arg) => arg.toLowerCase())
      .join("%20")
      .replace(/-/g, "%20");

    var data =
      "type=product&options%5bunavailable_products%5d=last&options%5bprefix%5d=none&q=" +
      final +
      "%20*";
    var re = /e(\W)?all.*in.*one/gi;
    data = data
      .replace(re, "e all in one")
      .replace(/\(remise à neuf\)|\(refurbished\)/g, "");

    var slug_js = "&view=compatibles";

    //console.log(data + slug_js);
    fetch("/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data + slug_js,
    })
      .then((response) => response.text())
      .then((result) => {
        var arr = result.split("||");
        //document.querySelector(".cartrighes-compatibles").innerHTML = arr[1];
        $(".cartrighes-compatibles").html(arr[1]);

        var filterCheckboxes = document.querySelectorAll(
          '.filters-compatibles_container input[type="checkbox"]'
        );
        var filterFunc = function () {
          var selectedFilters = {};
          filterCheckboxes.forEach(function (checkbox) {
            if (checkbox.checked) {
              selectedFilters[checkbox.name] =
                selectedFilters[checkbox.name] || [];
              selectedFilters[checkbox.name].push(checkbox.value);
            }
          });

          var filteredResults = document.querySelectorAll(
            ".cartrighes-compatibles .compatible_filter"
          );
          filteredResults.forEach(function (result) {
            result.style.display = "none";
          });

          Object.keys(selectedFilters).forEach(function (name) {
            filteredResults.forEach(function (result) {
              var currentFilterValues = result.dataset.category.split(" ");
              if (
                selectedFilters[name].some((value) =>
                  currentFilterValues.includes(value)
                )
              ) {
                result.style.display = "";
              }
            });
          });
        };

        filterCheckboxes.forEach(function (checkbox) {
          checkbox.addEventListener("change", filterFunc);
        });

        var titleContainers = document.querySelectorAll(
          ".product_title_keyser_container"
        );

        titleContainers.forEach(function (titleContainer) {
          var cartridges = [];
          var currentElement = titleContainer.nextElementSibling;

          // Récupérer tous les éléments .compatible-item-cartridges jusqu'au prochain .product_title_keyser_container
          while (
            currentElement !== null &&
            !currentElement.classList.contains("product_title_keyser_container")
          ) {
            if (
              currentElement.classList.contains("compatible-item-cartridges")
            ) {
              cartridges.push(currentElement);
            }
            currentElement = currentElement.nextElementSibling;
          }

          // Trier les éléments .compatible-item-cartridges par data-category, puis par prix
          /*cartridges.sort(function (a, b) {
            var categoryA = a.getAttribute("data-category");
            var categoryB = b.getAttribute("data-category");

            if (categoryA !== categoryB) {
              // Tri par data-category
              return categoryA.localeCompare(categoryB);
            } else {
              // Tri par prix si les data-category sont identiques
              var priceA = parseFloat(
                a.querySelector(".money").innerText.replace("$", "")
              );
              var priceB = parseFloat(
                b.querySelector(".money").innerText.replace("$", "")
              );
              return priceB - priceA;
            }
          });*/s

          // Insérer les éléments triés après le titleContainer
          cartridges.forEach(function (item) {
            titleContainer.insertAdjacentElement("afterend", item);
          });
        });
      })
      .catch((error) => console.error("Error:", error));

    // Utilisation de la promesse résolue
  }
});
